import AddressListItem from './AddressListItem';

export default AddressListItem;
